import { useZionForm } from '@fs/zion-form'
import { object } from 'yup'
import { yupResolver } from '@hookform/resolvers/yup'
import { verificationCodeSchema } from '@fs/identity.js'
import { FieldNames, Urls } from '../constants'
import useShowError from './useShowError'
import verifyOneTimeToken from '../services/verifyOneTimeToken'
import { MultiValidationError } from '../errors'
import redirectAsync from '../utils/redirectAsync'

const resolver = yupResolver(
  object().shape({
    [FieldNames.VERIFICATION_CODE]: verificationCodeSchema,
  })
)

export default function useVerifyOneTimeTokenForm({ action } = {}) {
  const showError = useShowError()

  const defaultValues = {
    [FieldNames.VERIFICATION_CODE]: '',
  }
  const methods = useZionForm({
    mode: 'onSubmit',
    resolver,
    defaultValues,
  })

  const onSubmit = async (values) => {
    try {
      await verifyOneTimeToken(values, action)
    } catch (error) {
      if (error instanceof MultiValidationError) {
        error.errors.forEach((validationError, index) =>
          methods.setError(
            validationError.fieldName,
            { type: 'manual', message: validationError.render() },
            { shouldFocus: index === 0 }
          )
        )
      } else if (
        // XSRF-TOKEN issue
        error.response?.status === 403 ||
        // SESSION issue (normally would just expect a redirect to restart flow in this case)
        error.response?.status === 401
      ) {
        await redirectAsync(Urls.SESSION_EXPIRED)
      } else {
        showError(error)
      }
    }
  }
  return { methods, onSubmit }
}
